export type CourseMode = 'polycfd' | 'polycfdamr';
export function courseFromSearch(search: string): CourseMode {
  return new URLSearchParams(search).get('course') === 'polycfdamr' ? 'polycfdamr' : 'polycfd';
}
export const isAmr = typeof window !== 'undefined' && courseFromSearch(window.location.search) === 'polycfdamr';
export const courseName = isAmr ? 'PolyCfdAmr' : 'PolyCFD';
export const courseChapterId = (id: string) => isAmr && !id.startsWith('amr-') ? `amr-${id}` : id;
export const courseHref = (mode: CourseMode, hash = '#/') => `?course=${mode}${hash}`;
